module.exports = __webpack_public_path__ + "static/media/atsundown-logo.de786717.webp";